// extracted by mini-css-extract-plugin
export default {"switch":"LatestSwitch_switch__6EVfo"};